export default "__VITE_ASSET__BoZej347__"